export const CANNOT_DEACTIVATE_ONLY_USER_MSG =
  "Cannot deactivate the only user in the organization.";

export const CANNOT_DEACTIVATE_LAST_ACTIVE_MSG =
  "Cannot deactivate the last active user. At least one user must remain active.";

export function isUserActiveForToggle(user) {
  if (!user) return false;
  if (user.__is_active_for_toggle !== undefined) {
    return Boolean(user.__is_active_for_toggle);
  }
  const value = user.is_active;
  return value === true || value === 1 || value === "1" || value === "Active";
}

export function cannotDeactivateOrganizationUser(user, paginationMeta = {}) {
  if (!isUserActiveForToggle(user)) return false;

  const totalUsers = Number(
    paginationMeta?.total_users_count ?? paginationMeta?.total ?? 0
  );
  const activeUsers = Number(paginationMeta?.active_users_count ?? 0);

  if (totalUsers <= 1) return true;
  if (activeUsers > 0 && activeUsers <= 1) return true;

  return false;
}

export function getCannotDeactivateMessage(paginationMeta = {}) {
  const totalUsers = Number(
    paginationMeta?.total_users_count ?? paginationMeta?.total ?? 0
  );

  if (totalUsers <= 1) {
    return CANNOT_DEACTIVATE_ONLY_USER_MSG;
  }

  return CANNOT_DEACTIVATE_LAST_ACTIVE_MSG;
}

export function extractToggleStatusError(error) {
  const data = error?.response?.data;

  return (
    data?.error ||
    data?.message ||
    data?.errors?.is_active?.[0] ||
    (typeof data?.errors === "string" ? data.errors : null) ||
    "Failed to update user status"
  );
}

export const CANNOT_DEACTIVATE_SELF_MSG =
  "You cannot deactivate your own account.";

export function isCurrentOrganizationUser(row, currentUser) {
  if (!row || !currentUser) return false;
  const orgIds = [
    currentUser.organizationuser?.organization_user_id,
    currentUser.organization_user?.organization_user_id,
    currentUser.organization_user_id,
    ...(Array.isArray(currentUser.metadata)
      ? currentUser.metadata.map((item) => item?.organization_user_id)
      : []),
  ].filter((value) => value != null && value !== "");
  const appIds = [
    currentUser.application_user_id,
    currentUser.user_id,
    currentUser.applicationuser?.application_user_id,
    Array.isArray(currentUser.applicationuser)
      ? currentUser.applicationuser[0]?.application_user_id
      : null,
  ].filter((value) => value != null && value !== "");
  const rowOrg =
    row.organization_user_id ?? row.organization_user?.organization_user_id;
  const rowApp =
    row.application_user_id ?? row.application_user?.application_user_id;
  if (rowOrg != null && orgIds.length > 0) {
    return orgIds.some((id) => String(id) === String(rowOrg));
  }
  if (rowOrg != null && orgIds.length === 0 && rowApp != null) {
    return appIds.some((id) => String(id) === String(rowApp));
  }
  if (rowOrg == null && rowApp != null && appIds.some((id) => String(id) === String(rowApp))) {
    return true;
  }
  return false;
}

export function withUserToggleGuard(row, paginationMeta = {}, currentUser = null) {
  if (isCurrentOrganizationUser(row, currentUser)) {
    return {
      ...row,
      __toggle_active_disabled: true,
      __toggle_active_disabled_reason: CANNOT_DEACTIVATE_SELF_MSG,
    };
  }

  const blocked = cannotDeactivateOrganizationUser(row, paginationMeta);

  return {
    ...row,
    __toggle_active_disabled: blocked,
    __toggle_active_disabled_reason: blocked
      ? getCannotDeactivateMessage(paginationMeta)
      : "",
  };
}
